<div
  class="h-full py-1 bg-gray-100/50 border border-gray-200/50 rounded-xl grid grid-rows-3 grid-flow-col gap-x-2 px-1">
  <ng-content></ng-content>
</div>
